export const carousel = {
  "Minha Equipe": "Minha Equipe",
  "Sem registro": "Sem registro"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/carousel.js